export default "__VITE_ASSET__CU3z76rb__"